module.exports = __webpack_public_path__ + "img/select-check-on.a137fc7b.svg";